import { IOverviewReportSummaryData } from 'schemas';

interface IUseSummaryValuesReturn {
  getValue: (title: string, mod?: boolean) => string | number;
}
export const useSummaryValues = (
  data: IOverviewReportSummaryData[] | undefined,
  loading: boolean
): IUseSummaryValuesReturn => {
  const getValue = (title: string, mod?: boolean): string | number => {
    if (loading) return '—';
    const value = data?.find((item) => item.title === title)?.value;
    return value !== undefined ? value : mod ? '0' : '—';
  };

  return { getValue };
};

export const formatMoney = (m: number | string | null, cur?: string): string =>
  `${m?.toLocaleString(undefined, { maximumFractionDigits: 2 })} ${
    cur ? cur : ''
  }`;
